/* Product Studio: editorial desktop photos, native mobile swipe and opt-in film. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const compactGallery = window.matchMedia('(max-width: 749px)');
  const gallery = document.querySelector('[data-studio-gallery]');
  if (gallery) {
    const track = gallery.querySelector('.studio-track');
    const slides = [...track.querySelectorAll('.studio-slide')];
    const counter = gallery.querySelector('[data-studio-count]');
    let current = 0, requested = null, ticking = false;
    const update = index => {
      current = Math.max(0, Math.min(slides.length - 1, index));
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      const prev = gallery.querySelector('[data-studio-prev]');
      const next = gallery.querySelector('[data-studio-next]');
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
      slides.forEach((slide, i) => {
        if (i !== current) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    };
    const go = index => {
      if (!compactGallery.matches) return;
      const next = Math.max(0, Math.min(slides.length - 1, index));
      const target = slides[next];
      if (!target) return;
      const left = target.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      requested = next;
      track.scrollTo({left, behavior: reduce.matches ? 'instant' : 'smooth'});
      update(next);
    };
    gallery.addEventListener('click', event => {
      const target = event.target.closest('[data-studio-prev], [data-studio-next]');
      if (!target) return;
      event.preventDefault();
      if (target.hasAttribute('data-studio-prev')) go((requested ?? current) - 1);
      else if (target.hasAttribute('data-studio-next')) go((requested ?? current) + 1);
    });
    track.addEventListener('keydown', event => {
      if (!compactGallery.matches || event.target !== track) return;
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (requested ?? current) + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('scroll', () => {
      if (!compactGallery.matches || ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const left = track.getBoundingClientRect().left;
        let nearest = 0, distance = Infinity;
        slides.forEach((slide, index) => {const d = Math.abs(slide.getBoundingClientRect().left - left); if (d < distance) {distance = d; nearest = index;}});
        update(nearest);
        if (requested !== null && Math.abs(slides[requested].getBoundingClientRect().left - left) < 2) requested = null;
        ticking = false;
      });
    }, {passive: true});
    track.addEventListener('pointerdown', () => {requested = null;}, {passive:true});
    track.addEventListener('wheel', () => {requested = null;}, {passive:true});
    track.addEventListener('scrollend', () => {requested = null;});
    const syncLayout = () => {
      track.tabIndex = compactGallery.matches ? 0 : -1;
      requested = null;
      track.scrollTo({left:0, behavior:'instant'});
      update(0);
    };
    compactGallery.addEventListener('change', syncLayout);
    syncLayout();
  }
  const details = document.querySelector('.product-page-studio .product-details');
  if (details) {
    const fitSidebar = () => {
      const top = Math.min(104, window.innerHeight - details.getBoundingClientRect().height - 24);
      details.style.setProperty('--studio-info-top', `${Math.round(top)}px`);
    };
    if ('ResizeObserver' in window) new ResizeObserver(fitSidebar).observe(details);
    window.addEventListener('resize', fitSidebar, {passive:true});
    fitSidebar();
  }
  document.querySelectorAll('[data-inspect]').forEach(section => {
    const figures = [...section.querySelectorAll('[data-inspect-view]')];
    const buttons = [...section.querySelectorAll('[data-inspect-select]')];
    let animation;
    const zoom = section.querySelector('[data-inspect-zoom]');
    zoom?.addEventListener('click', () => {const active = section.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(active));});
    const select = (name, animate = true) => {
      animation?.cancel(); section.classList.remove('is-zoomed'); zoom?.setAttribute('aria-pressed', 'false');
      figures.forEach(figure => {
        figure.hidden = figure.dataset.inspectView !== name;
        if (!figure.hidden && animate && !reduce.matches && figure.animate) animation = figure.animate([{opacity: .2, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 260, easing: 'cubic-bezier(.22,1,.36,1)'});
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.inspectSelect === name)));
    };
    buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.inspectSelect)));
    section.classList.add('is-ready'); select('back', false);
  });
  const form = document.querySelector('.product-page-studio [data-product-form]');
  const selection = document.querySelector('[data-studio-selection]');
  const updateSelection = () => {const size = form?.querySelector('select[name="id"]')?.selectedOptions[0]?.dataset.size; if (selection) {selection.textContent = size || ''; selection.hidden = !size;}};
  form?.addEventListener('change', updateSelection); updateSelection();
  // Preserve the installed app's own visibility rules and registration handler.
  // Only relocate its existing trigger; no subscriptions or app settings are changed.
  const restock = document.querySelector('[data-studio-restock]');
  if (restock) {
    const mountRestock = () => {
      const trigger = document.querySelector('.bis-reset .bis-button.BIS_trigger');
      const wrapper = trigger?.closest('.bis-reset');
      if (!wrapper) return;
      if (!restock.contains(wrapper)) restock.append(wrapper);
      if (trigger.dataset.studioRestockReady) return;
      trigger.dataset.studioRestockReady = 'true';
      trigger.textContent = restock.dataset.restockLabel;
      trigger.setAttribute('tabindex', '0');
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault(); trigger.click();
      });
    };
    mountRestock();
    // The app appends its floating trigger directly to body, sometimes after load.
    const restockObserver = new MutationObserver(mountRestock);
    restockObserver.observe(document.body, {childList:true});
    window.addEventListener('pagehide', () => restockObserver.disconnect(), {once:true});
  }
  const dialog = document.querySelector('[data-film-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const video = dialog.querySelector('[data-film-video]');
  const error = dialog.querySelector('[data-film-error]');
  let opener = null;
  document.querySelectorAll('[data-film-open]').forEach(trigger => trigger.addEventListener('click', event => {
    event.preventDefault(); opener = trigger; error.hidden = true;
    if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
    if (!dialog.open) dialog.showModal();
    video.play().catch(() => { /* Native controls remain available if browser blocks playback. */ });
  }));
  video.addEventListener('error', () => {error.hidden = false;});
  dialog.querySelector('[data-film-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {video.pause(); video.removeAttribute('src'); video.load(); error.hidden = true; opener?.focus({preventScroll:true});});
})();
